<app-details [tsl-showAdditionalDetailsLink]="true" (tsl-supplierCodeChanged)="supplierCodeChangeEventHandler($event.selectedSupplierCode)">
</app-details>
<app-banner *ngIf="supplierCode" [suppliercode]="supplierCode" class="header-area"></app-banner>
<div class="profile" [class.selected]="supplierCode">
  <div class="my_scroll_div">
    <app-sidenav *ngIf="supplierCode"></app-sidenav>
  </div>
  <div class="header-area">
    <div class="banner-container" *ngIf="supplierCode && showSubtierOnboarding">
      <tsl-alert status="error">
        <tsl-label>You are assigned to complete your organization's subtier onboarding. Please <a
            href="javascript:void(0)" (click)="navigateToTaskHomePage()">click here</a> to start the process.
        </tsl-label>
      </tsl-alert>
    </div>
    <div class="banner-container" *ngIf="otpRequest && otpRequest.status && !otpRequest.isExpired
    && !['Verified', 'Locked', 'UserFailed', 'Unlocked'].includes(otpRequest?.status)">
      <tsl-alert status="error">
        <tsl-label>
          <b i18n="@@OneTimePassword" t="OneTimePassword">One-Time Password (OTP):</b>
          <span i18n="@@OTPDescription" t="OTPDescription">You received a one-time password for verification purposes.
            Please click following link to retrieve your one-time password. This password expires in 30 minutes from the
            time it was initiated.</span>
          <a href="javascript:void(0)" (click)="showOTP()" i18n="@@Here" t="Here">HERE</a>
        </tsl-label>
      </tsl-alert>
    </div>
    <div class="app-info" [hidden]="!supplierCode">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="user-action-container" *ngIf="supplierCode && !preventativeHold">
    <div class="action-container" *ngIf="actionList?.length > 0">
      <ng-container *ngFor="let action of actionList">
        <div *ngIf="(!isPCFUploaded && !showMFADialog) || isPCFValidationInProgress" tslTooltip="{{translate.get(isContactValidationPendingTaskErrorMessage)}}">
          <a [ngClass]="{'link-disable': !isPCFUploaded && !showMFADialog}" (click)="onActionClick(action)">{{ translate.get(action) }}</a>
        </div>
        <div *ngIf="!((!isPCFUploaded && !showMFADialog) || isPCFValidationInProgress)">
          <a [ngClass]="{'text-button': true}" (click)="onActionClick(action)">{{ translate.get(action) }}</a>
        </div>
      </ng-container>
    </div>
    <div class="action-container">
      <app-request-list [supplierCode]="supplierCode" (onCancelSucceed)="onReload($event, true)"></app-request-list>
    </div>
  </div>
</div>
